import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Pricing } from "@/components/Pricing";
import { Work } from "@/components/Work";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useLenis();
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <Pricing />
      <Work />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
